import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
    InputSignal,
    model,
    ModelSignal,
    Signal,
} from '@angular/core';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { TranslatePipe } from '@ngx-translate/core';
import { Field, FieldState, FormField, FormValueControl, provideSignalFormsConfig } from '@angular/forms/signals';
import { NgClass } from '@angular/common';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { NG_STATUS_CLASSES } from '@angular/forms/signals/compat';
import { ValidationMessagePipe } from '@ui/pipes/validation-message/validation-message.pipe';


@Component({
    selector: 'ui-signal-form-select',
    imports: [
        NgLabelTemplateDirective,
        NgOptionTemplateDirective,
        NgSelectComponent,
        TranslatePipe,
        NgClass,
        FormField,
        ValidationMessagePipe,
    ],
    templateUrl: './signal-form-select.html',
    styleUrl: './signal-form-select.scss',
    hostDirectives: [{ directive: FormField, inputs: ['formField'] }],
    providers: [provideSignalFormsConfig({ classes: NG_STATUS_CLASSES })],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignalFormSelect implements FormValueControl<unknown> {
    readonly field: Signal<FieldState<unknown, string | number>> = inject(FormField).state;
    readonly value: ModelSignal<unknown> = model();
    readonly size: InputSignal<'sm' | 'lg'> = input<'sm' | 'lg'>(null);
    readonly additionalGroupClass: InputSignal<string> = input<string>(null);
    readonly addTagText: InputSignal<string> = input<string>(marker('global.actions.use'));
    readonly placeholder: InputSignal<string> = input<string>(null);
    readonly idAttrValue: InputSignal<string> = input<string>('ui-fs-' + Math.random().toString().replace('.', ''));
    readonly bindValue: InputSignal<string> = input<string>(null);
    readonly bindLabel: InputSignal<string> = input<string>('name');
    readonly label: InputSignal<string> = input<string>(null);
    readonly translateOptions: InputSignal<boolean> = input<boolean>(null);
    readonly required: InputSignal<boolean> = input<boolean>(false);
    readonly disabled: InputSignal<boolean> = input<boolean>(false);
    readonly invalid: InputSignal<boolean> = input<boolean>(false);
    readonly searchable: InputSignal<boolean> = input<boolean>(false);
    readonly clearable: InputSignal<boolean> = input<boolean>(true);
    readonly addTag: InputSignal<boolean> = input<boolean>(false);
    readonly multiple: InputSignal<boolean> = input<boolean>(false);
    readonly options: InputSignal<any[]> = input<any[]>();
    readonly formField: InputSignal<Field<unknown>> = input<Field<unknown>>(null);
}
